// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.role-view {
	background-color: white;
	border-radius: 12px;
	margin: 12px;
}

.role-view .page-title {
	display: flex;
	flex-direction: row;
	gap: 4px;
	font-size: 24px;
}

.role-view .page-actions {
	display: flex;
	flex-direction: row;
	gap: 24px;
	font-size: 24px;
}

.role-view .page-content {
	display: flex;
	flex-direction: row;
	gap: 24px;
}

.role-view .tree-view-container {
	border: 1px solid rgb(182, 182, 182);
	border-radius: 4px;
	padding: 16px 9px;
	height: 526px;
	overflow-y: scroll;
}
`, "",{"version":3,"sources":["webpack://./src/pages/permission/role/role-view/index.css"],"names":[],"mappings":"AAAA;CACC,uBAAuB;CACvB,mBAAmB;CACnB,YAAY;AACb;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,QAAQ;CACR,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,SAAS;CACT,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,oCAAoC;CACpC,kBAAkB;CAClB,iBAAiB;CACjB,aAAa;CACb,kBAAkB;AACnB","sourcesContent":[".role-view {\n\tbackground-color: white;\n\tborder-radius: 12px;\n\tmargin: 12px;\n}\n\n.role-view .page-title {\n\tdisplay: flex;\n\tflex-direction: row;\n\tgap: 4px;\n\tfont-size: 24px;\n}\n\n.role-view .page-actions {\n\tdisplay: flex;\n\tflex-direction: row;\n\tgap: 24px;\n\tfont-size: 24px;\n}\n\n.role-view .page-content {\n\tdisplay: flex;\n\tflex-direction: row;\n\tgap: 24px;\n}\n\n.role-view .tree-view-container {\n\tborder: 1px solid rgb(182, 182, 182);\n\tborder-radius: 4px;\n\tpadding: 16px 9px;\n\theight: 526px;\n\toverflow-y: scroll;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
